module.exports = __webpack_public_path__ + "img/icon-ecosystem-light.bddc4f12.svg";